import { FormEvent } from 'react'
import { Heading1, Heading3 } from '@entur/typography'
import { GridContainer, GridItem } from '@entur/grid'
import { PrimaryButton } from '@entur/button'
import { DownloadIcon } from '@entur/icons'
import { BannerAlertBox, useToast } from '@entur/alert'
import { space } from '@entur/tokens'
import { addMonths, differenceInDays, format, startOfMonth, subMonths } from 'date-fns'
import { FetchState } from '../../api-clients/api-types'
import { useDownloadableApi } from '../../api-clients/client-hooks'
import { getTicketWithoutTicketRightReport } from '../../api-clients/eba-clients'

const TicketsWithoutTicketRightReport = () => {
  const [downloadResponse, download] = useDownloadableApi(getTicketWithoutTicketRightReport)
  const { addToast } = useToast()
  const daysUntilNextScheduledReport = () => {
    const today = new Date(Date.now())
    return differenceInDays(startOfMonth(addMonths(today, 1)), today)
  }

  const dateOfGeneratedReport = () => {
    let today = new Date(Date.now())
    const isFirstDayAndAfter2UTC = today.getDate() === 1 && today.getUTCHours() >= 2
    const isAfterFirstDayOfMonth = today.getDate() > 1
    const reportHasGenerated = isAfterFirstDayOfMonth || isFirstDayAndAfter2UTC

    if (reportHasGenerated) {
      today = subMonths(today, 1)
    }

    return format(today, 'MMMM-yyyy')
  }

  const downloadReport = async (event: FormEvent) => {
    event?.preventDefault()
    addToast({ variant: 'info', content: 'Laster ned rapport ...' })
    download({
      query: `?format=csv`,
      backupFileName: `tickets-without-ticket-right.csv`,
    })
  }

  return (
    <div>
      <Heading1>Rapport for billetter uten rettighet</Heading1>

      <form
        data-cy="tickets-without-ticket-right-report-form"
        id="ticket-without-ticket-right-report__form"
        onSubmit={downloadReport}
      >
        <GridContainer spacing="medium">
          <GridItem small={12} medium={12}>
            <Heading3 margin="bottom">Neste rapport</Heading3>
            {daysUntilNextScheduledReport()} dager til neste rapport er tilgjengelig
          </GridItem>

          <GridItem small={12} medium={12}>
            <Heading3 margin="bottom">Tilgjengelig rapport</Heading3>
            {dateOfGeneratedReport()}
          </GridItem>
          <GridItem small={12} medium={6} large={6}>
            <PrimaryButton
              id="submit-btn"
              className="ticket-without-ticket-right_report__form-button"
              data-cy="ticket-without-ticket-right-report-download-csv"
              type="submit"
              loading={downloadResponse.status === FetchState.LOADING}
            >
              <DownloadIcon /> Last ned CSV
            </PrimaryButton>
          </GridItem>
        </GridContainer>
        {downloadResponse.status === FetchState.ERROR && (
          <BannerAlertBox
            variant="error"
            title="Kan ikke laste ned rapport"
            closable={true}
            style={{ marginBottom: space.large, marginTop: space.large }}
          >
            Prøv på nytt eller ta kontakt med Entur support om det vedvarer.
          </BannerAlertBox>
        )}
      </form>
    </div>
  )
}

export default TicketsWithoutTicketRightReport
